export const GLOBALS = {
  name: 'PROD',
  production: true,
  apiConfiguration: {
    baseUrl: 'https://api.band-manager.app',
  },
  translation_path: './assets/i18n/',
  passwordPattern: '^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[@.#$!%*?&]).{8,}$',
  passwordMinLength: 8,
  firebase_config: {
    vapidKey: 'BMUABf_ZcKy47TgSpsPD-deyib_IQ7nJOCL-36YLwjaXtJbpL4mvydktSTOyVCqBrcQcDlYQMSJxI40ogtJmBVo',
    apiKey: 'AIzaSyBhzuPD0-Na44hAJRWjN2xO4PFrEdIQogo',
    authDomain: 'bandmanager-2b4db.firebaseapp.com',
    projectId: 'bandmanager-2b4db',
    storageBucket: 'bandmanager-2b4db.firebasestorage.app',
    messagingSenderId: '889256302510',
    appId: '1:889256302510:web:5d87b18ec98ea26aa11a3f',
    measurementId: 'G-PJ7TS0QFQ3',
  },
};
